import { Subject } from 'rxjs';

const subject = new Subject();

export const showModal = {
  sendMessage: (state: any) => subject.next(state),
  onMessage: () => subject.asObservable(),
};
